"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CXTupleToDefaultPreferencesArgs = void 0;
const config_type_1 = require("../config-type");
const i18n_args_1 = require("./i18n-args");
/**
 * Input args to be used to query CXTuple defaults.
 */
class CXTupleToDefaultPreferencesArgs extends i18n_args_1.I18nArgs {
    constructor(_cxFamily, _cxId, _cxProgram) {
        super();
        this._cxFamily = _cxFamily;
        this._cxId = _cxId;
        this._cxProgram = _cxProgram;
    }
    getConfigType() {
        return config_type_1.ConfigType.CX_TUPLE_TO_DEFAULT_PREFERENCES;
    }
    getArgsMap() {
        return new Map([
            ['cx_family', this._cxFamily],
            ['cx_id', this._cxId],
            ['cx_program', this._cxProgram]
        ]);
    }
    get cxFamily() {
        return this._cxFamily;
    }
    get cxId() {
        return this._cxId;
    }
    get cxProgram() {
        return this._cxProgram;
    }
}
exports.CXTupleToDefaultPreferencesArgs = CXTupleToDefaultPreferencesArgs;
/**
 * Builder class that build the {@link CXTupleToDefaultPreferencesArgs} instance.
 */
CXTupleToDefaultPreferencesArgs.Builder = class {
    /**
     * Sets the CXFamily within the {@link CXTupleToDefaultPreferencesArgs}
     * container.
     *
     * @param cxFamily CXFamily to be used for the config query.
     *
     * @return builder instance
     */
    withCxFamily(cxFamily) {
        this.cxFamily = cxFamily;
        return this;
    }
    /**
     * Sets the CXId within the {@link CXTupleToDefaultPreferencesArgs}
     * container.
     *
     * @param cxId CXId to be used for the config query.
     *
     * @return builder instance
     */
    withCxId(cxId) {
        this.cxId = cxId;
        return this;
    }
    /**
     * Sets the CXProgram within the {@link CXTupleToDefaultPreferencesArgs}
     * container.
     *
     * @param CXProgram CXProgram to be used for the config query.
     *
     * @return builder instance
     */
    withCxProgram(cxProgram) {
        this.cxProgram = cxProgram;
        return this;
    }
    /**
     * Builds the {@link CXTupleToDefaultPreferencesArgs} class using the previously set
     * properties.
     *
     * @return {@link CXTupleToDefaultPreferences} class instance
     */
    build() {
        return new CXTupleToDefaultPreferencesArgs(this.cxFamily, this.cxId, this.cxProgram);
    }
};
//# sourceMappingURL=cx-tuple-to-default-preferences-args.js.map